import McValidationService from '@mgServices/mc-validation.service';
import type { StateStatus } from '@mgStore/types';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

type McValidationState = {
  customerKey: string;
  deTableName: string;
  columns: string[];
  status: StateStatus;
  error: string | null;
};

type ValidateDeTableArgs = {
  fuel2token?: string | null;
  deName?: string | null;
};

type GetValidationColumnsArgs = {
  fuel2token?: string | null;
  key?: string | null;
  entry?: string | null;
};

const initialState: McValidationState = {
  customerKey: '',
  deTableName: '',
  columns: [],
  status: 'idle',
  error: null,
};

export const validateDeTable = createAsyncThunk<{ customerKey: string; name: string }, ValidateDeTableArgs>(
  'mcValidation/validateDeTable',
  async ({ fuel2token = null, deName = null }) => {
    const res = await McValidationService.validateDeTable({ fuel2token, deName });
    return res.data;
  }
);

export const getValidationColumns = createAsyncThunk<string[], GetValidationColumnsArgs>(
  'mcValidation/getValidationColumns',
  async ({ fuel2token = null, key = null, entry = null }) => {
    const res = await McValidationService.getValidationColumns({ fuel2token, key, entry });
    return res.data?.result;
  }
);

const mcValidationSlice = createSlice({
  name: 'mcValidation',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(validateDeTable.pending, state => {
        state.status = 'loading';
      })
      .addCase(validateDeTable.fulfilled, (state, action: PayloadAction<{ customerKey: string; name: string }>) => {
        state.customerKey = action.payload.customerKey;
        state.deTableName = action.payload.name;
        state.status = 'succeeded';
      })
      .addCase(validateDeTable.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || null;
      })
      .addCase(getValidationColumns.pending, state => {
        state.status = 'loading';
      })
      .addCase(getValidationColumns.fulfilled, (state, action: PayloadAction<string[]>) => {
        state.columns = action.payload;
        state.status = 'succeeded';
      })
      .addCase(getValidationColumns.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || null;
      });
  },
});

export default mcValidationSlice.reducer;
